import { render, staticRenderFns } from "./guardianWizard.vue?vue&type=template&id=8e168670"
import script from "./guardianWizard.vue?vue&type=script&lang=js"
export * from "./guardianWizard.vue?vue&type=script&lang=js"
import style0 from "./guardianWizard.vue?vue&type=style&index=0&id=8e168670&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports